<div class="p-4">
  <a [routerLink]="backLink" [queryParams]="backParams" [state]="backState" class="text-sm underline text-grey-700">&lt; {{backLabel}}</a>
  <h1 class="text-2xl font-semibold mt-2 mb-4">Action Details</h1>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <div class="flex flex-col gap-4">
      <app-action-summary-card
        [action]="action"
        [users]="users"
        [editing]="editingSummary"
        [validationError]="validationError"
        [descriptionError]="descriptionError"
        [assigneeError]="assigneeError"
        [dateError]="dateError"
        (updateAssignee)="updateAssignee($event)"
        (updateDeadline)="updateDeadline($event)"
        (toggleEdit)="toggleSummaryEdit()"
        (toggleResolved)="toggleResolved()">
      </app-action-summary-card>

      <app-action-updates
        [updates]="updates"
        [saving]="updateSaving"
        [errorMessage]="updateError"
        (addUpdate)="addUpdate($event)">
      </app-action-updates>

      @if (!childAdding) {
        <app-action-children
          [childActions]="childActions"
          (createChild)="startChildAdd()"
          (openChild)="openChild($event)">
        </app-action-children>
      }
      @if (childAdding) {
        <app-event-action-add
          [eventId]="action.EventID"
          [locationId]="action.AuditLocation.LocationID"
          [users]="users"
          [saving]="childSaving"
          [auditOptions]="actionAuditOptions"
          [auditsLoading]="loadingActionAudits"
          [resetToken]="childResetToken"
          (saveAction)="saveChildAction($event)"
          (cancel)="cancelChildAdd()">
        </app-event-action-add>
      }
    </div>

    <div class="flex flex-col gap-4">
      <app-action-context-card
        [contextType]="contextType"
        [title]="contextTitle"
        [subtitle]="contextSubtitle"
        [body]="contextBody"
        [meta]="contextMeta">
      </app-action-context-card>

      <app-action-history-timeline
        [history]="history">
      </app-action-history-timeline>

      <app-action-assets
        [photos]="photos"
        (downloadPhoto)="downloadPhoto($event)"
        (removePhoto)="confirmRemovePhoto($event)"
        [attachments]="attachments"
        [uploadingPhoto]="photoUploading"
        [uploadingAttachment]="attachmentUploading"
        [errorMessage]="assetError"
        (uploadPhoto)="handlePhotoUpload($event)"
        (uploadAttachment)="handleAttachmentUpload($event)"
        (capturePhoto)="handleCapturedPhoto($event)"
        (downloadAttachment)="downloadAttachment($event)"
        (removeAttachment)="confirmRemoveAttachment($event)">
      </app-action-assets>
      <p-confirmpopup key="actionConfirm" styleClass="confirm-popup-danger">
        <ng-template pTemplate="headless" let-confirmation>
          <div class="confirm-popup-wrapper flex items-start gap-3">
            <i class="pi pi-exclamation-triangle text-danger-base text-xl"></i>
            <div class="flex flex-col gap-3 w-full">
              <div>
                <p class="font-semibold">{{confirmation?.header || 'Remove attachment'}}</p>
                <p class="text-sm">{{confirmation?.message || 'Are you sure you want to remove this attachment?'}}</p>
              </div>
              <div class="flex gap-2 justify-end w-full">
                <button type="button" class="btn-inverse btn-compact btn-xs confirm-keep-btn" (click)="onConfirmReject(confirmation)">
                  <i class="pi pi-undo mr-1"></i>
                  <span>Keep</span>
                </button>
                <button type="button" class="btn-negative btn-compact btn-xs confirm-remove-btn" (click)="onConfirmAccept(confirmation)">
                  <i class="pi pi-trash mr-1"></i>
                  <span>Remove</span>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </p-confirmpopup>

      @if (showAuditRequirementPanel) {
        <div class="card-section">
          <h3 class="section-title">Required {{ 'audit' | customerTerm }}</h3>
          <p class="text-sm text-grey-700 mb-2">This action requires the following audit to be completed.</p>
          @if (action.AuditResultID && action.AuditResultID > 0) {
            <div class="audit-requirement">
              <div class="audit-name">{{getRequiredAuditName() || ('audit' | customerTerm)}}</div>
              <div class="text-xs text-grey-700 mt-1">
                Completed {{action.AuditCompletedDate | date:'mediumDate'}} by {{action.AuditCompletedBy || 'Unknown'}}
              </div>
            </div>
          }
          @if (!action.AuditResultID || action.AuditResultID <= 0) {
            <div class="audit-requirement">
              <div class="audit-header">
                <div class="audit-name">{{getRequiredAuditName() || ('audit' | customerTerm)}}</div>
                <button class="btn-inverse btn-compact btn-small" type="button" (click)="toggleAuditSelector()">
                  <i class="pi" [ngClass]="showAuditSelector ? 'pi-times' : 'pi-plus'"></i>
                  <span class="ml-1">{{showAuditSelector ? 'Cancel' : 'Add'}}</span>
                </button>
              </div>
              @if (showAuditSelector) {
                <div class="mt-2 flex flex-col gap-2">
                    <p-select
                    class="w-full"
                    [options]="eligibleAudits"
                    optionLabel="label"
                    optionValue="value"
                    optionDisabled="disabled"
                    defaultLabel="Please Select..."
                    [(ngModel)]="selectedAuditResultId">
                    <ng-template pTemplate="item" let-opt>
                      <div class="flex flex-col">
                        <span class="font-semibold">{{opt?.label}}</span>
                        <span class="text-xs text-grey-700">{{opt?.meta}}</span>
                      </div>
                    </ng-template>
                  </p-select>
                  <div class="flex justify-end">
                    <button class="btn-primary btn-compact btn-small" type="button" (click)="attachSelectedAudit()" [disabled]="attachingAudit || !selectedAuditResultId || selectedAuditResultId <= 0">
                      <i class="pi" [ngClass]="attachingAudit ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                      <span class="ml-1">{{attachingAudit ? 'Adding...' : 'Add to Action'}}</span>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
